import { Directive, ElementRef, HostListener } from '@angular/core';
import { TouchKeyboardService } from '../../vu/services/touch-keyboard.service';
import { ComponentRect } from '../../vu/models/component-rect';
import { ShopSettingsService } from '../services/shop-settings.service';

@Directive({
  selector: '[appTouchKeyboard]'
})
export class TouchKeyboardDirective {

  constructor(
    private el: ElementRef,
    private shopSettingsService: ShopSettingsService,
    private touchKeyboardService: TouchKeyboardService,
  ) {
  }

  @HostListener('focus') focus() {
    if (this.shopSettingsService.isVUMode) {
      const elementClientRect = this.el.nativeElement.getBoundingClientRect();
      this.touchKeyboardService.show(ComponentRect.createFromClientRect(elementClientRect));
    }
  }

  @HostListener('focusout') focusout() {
    if (this.shopSettingsService.isVUMode) {
      this.touchKeyboardService.hide();
    }
  }

}
